import { type Location, useCreateNewLocationLocationPost } from "kubb";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { EntityForm } from "../../../components/Forms/EntityForm";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";
import { useEntityForm } from "../../../hooks/useEntityForm";
import { locationSchema } from "../../../model/location";

interface ComponentProps {
  company_id: string;
  scheme_id: string;
}

interface FormValues {
  scheme_id: string;
  address: string;
}

type Props = ComponentProps;

const NewLocationForm = ({ company_id, scheme_id }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutateAsync } = useCreateNewLocationLocationPost();

  const { error, onSubmit } = useEntityForm<FormValues, Location>({
    mutate: (values) =>
      mutateAsync({ data: { ...values, company_id, scheme_id } }),
    onSuccess: (response) =>
      navigate({
        ...location,
        pathname: `/admin/location/${response.data.location_id}`,
      }),
  });

  return (
    <EntityForm
      initialValues={{ address: "", scheme_id: "" }}
      validationSchema={Yup.object().shape(locationSchema)}
      onSubmit={onSubmit}
      error={error}
      submitLabel="Create"
    >
      <NewTextFormComponent
        fieldName={"address"}
        label={{ label: "Address" }}
      />
    </EntityForm>
  );
};

export default NewLocationForm;
